// While a visitor looks round the studio, the city's files are fetched into the browser's HTTP cache, without building
// anything: building the city (physics, traffic, the shader warm-up) would stall the room's frames, so that waits for
// the Drive button. The list and sizes were measured from a city load (2026-10-21); they only weight the progress ring,
// and a file missing here is simply fetched by the city itself.
const CITY_FILES: Array<[string, number]> = [
  ['/data/PLAYABLE_WORLD_LAYOUT_C.json', 460041],
  ['/assets/DhakaWorld_Playable_Gate1C.glb', 5725132],
  ['/models/vehicles/dhaka_car_corolla_silver_lod0.glb', 1395624],
  ['/models/vehicles/dhaka_car_corolla_silver_lod1.glb', 918124],
  ['/models/vehicles/dhaka_car_corolla_silver_lod2.glb', 361344],
  ['/models/vehicles/dhaka_rickshaw_decorated_lod1.glb', 815072],
  ['/models/vehicles/dhaka_rickshaw_decorated_lod2.glb', 636072],
  ['/models/vehicles/dhaka_cng_green_black_lod1.glb', 806912],
  ['/models/vehicles/dhaka_cng_green_black_lod2.glb', 339600],
  ['/models/vehicles/dhaka_bus_local_red_green_lod1.glb', 1282196],
  ['/models/vehicles/dhaka_bus_local_red_green_lod2.glb', 625652],
  ['/models/vehicles/dhaka_bus_brtc_double_lod1.glb', 1620068],
  ['/models/vehicles/dhaka_bus_brtc_double_lod2.glb', 619836],
  ['/models/vehicles/dhaka_bus_brtc_single_lod1.glb', 1197616],
  ['/models/vehicles/dhaka_bus_brtc_single_lod2.glb', 517124],
];

/** Download the city's files; `progress` gets the share of bytes received (0..1), and 1 when all are in. */
export async function prefetchCity(progress: (f: number) => void) {
  // a visitor saving data, or on a slow link, is not charged 17 MB they may never use: the city downloads on Drive
  const net = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
  if (net?.saveData || /(^|-)(2g|3g)$/.test(net?.effectiveType ?? '')) { progress(1); return; }
  const total = CITY_FILES.reduce((s, [, n]) => s + n, 0);
  const got = new Map<string, number>();
  const report = () => progress(Math.min(0.999, CITY_FILES.reduce((s, [u, n]) => s + Math.min(n, got.get(u) ?? 0), 0) / total));
  await Promise.all(CITY_FILES.map(async ([url, size]) => {
    try {
      const res = await fetch(url, { priority: 'low' } as RequestInit);
      const reader = res.body?.getReader();
      if (!reader) { await res.arrayBuffer(); got.set(url, size); report(); return; }
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        got.set(url, (got.get(url) ?? 0) + value.length);
        report();
      }
    } catch { /* offline or blocked: the city fetches it again when it builds */ }
    got.set(url, size);
    report();
  }));
  progress(1);
}
